// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"10c4219f","165":"64154848","232":"cb2cab12","453":"befa3028","729":"dfe2ef8c","796":"1d59b74d"}[chunkId] + ".chunk.js";
};